export function areStringArraysEqual(arr1: string[], arr2: string[]): boolean {
  if (arr1.length !== arr2.length) {
    return false;
  }

  for (const e of arr1) {
    if (arr2.indexOf(e) === -1) {
      return false;
    }
  }
  return true;
}
